import React from "react";
import NodeNetwork from "./NodeNetwork";

// Drop-in "Gatsby" node-network background: place it as the first child of any
// `relative overflow-hidden` section; it fills the section and later `relative` content sits on top.
//   <NetworkBackground />                       quiet under a headline on the start side
//   <NetworkBackground fade="none" />           even across the whole section
//   <NetworkBackground className="-z-10" />     inside an `isolate` section with other -z layers
const NetworkBackground = ({ fade = "start", className = "" }) => (
  <NodeNetwork fadeStart={fade === "start"} className={`absolute inset-0 h-full w-full ${className}`} />
);

export default NetworkBackground;
